import { MouseEvent } from 'react'

import { EMPTY_VALUE } from '@/constants/ui'
import { formatPhoneNumberDisplay, getTelHref } from '@/utils/phone-number'

import * as S from './phone-link.styled'

export interface PhoneLinkProps {
  phone?: string | number | null
}

// Note: stops propagation so a click inside a clickable table row dials instead of opening the row
const stopPropagation = (event: MouseEvent) => event.stopPropagation()

export const PhoneLink = ({ phone }: PhoneLinkProps) => {
  const label = formatPhoneNumberDisplay(phone)

  if (!phone || !label) return <>{EMPTY_VALUE}</>

  return (
    <S.Anchor href={getTelHref(phone)} onClick={stopPropagation}>
      {label}
    </S.Anchor>
  )
}
